import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileCode2, ShieldCheck, ShieldAlert } from "lucide-react";
import { Button } from "./ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAME = { zugferd: "ZUGFeRD", xrechnung: "XRechnung" };

const PruefStatus = ({ p }) => (
  <div className={`flex items-center gap-1 text-xs ${p.bestanden ? "text-green-700" : "text-red-700"}`} data-testid={`erechnung-pruefung-${p.art}`}>
    {p.bestanden ? <ShieldCheck size={14} /> : <ShieldAlert size={14} />}
    {NAME[p.art]}: {p.bestanden ? "Prüfung bestanden" : `${p.fehler.length} Fehler`}{p.warnungen?.length ? ` · ${p.warnungen.length} Hinweis(e)` : ""} · {new Date(p.geprueft_am).toLocaleString("de-DE")}
  </div>
);

const FehlerListe = ({ fehler, onVorschau }) => (
  <div className="mt-2 rounded border border-red-200 bg-red-50 p-2 text-xs" data-testid="erechnung-fehlerliste">
    <div className="font-semibold text-red-800">{NAME[fehler.art]} hat die Prüfung nicht bestanden:</div>
    <ul className="mt-1 list-disc pl-4">{fehler.fehler.map((f, i) => <li key={i}><b>{f.regel}</b> {f.text}</li>)}</ul>
    <Button variant="outline" size="sm" className="mt-2" onClick={onVorschau} data-testid="erechnung-vorschau-btn">Nur als Vorschau herunterladen</Button>
  </div>
);

export const ERechnungButtons = ({ rechnung }) => {
  const [pruefungen, setPruefungen] = useState([]);
  const [fehler, setFehler] = useState(null);
  const ladePruefungen = () => axios.get(`${API}/rechnungen/${rechnung.id}/erechnung-pruefung`).then((r) => setPruefungen(r.data)).catch(() => {});
  useEffect(() => { ladePruefungen(); }, [rechnung.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const laden = async (art, vorschau = false) => {
    setFehler(null);
    try {
      const res = await axios.get(`${API}/rechnungen/${rechnung.id}/${art}${vorschau ? "?vorschau=true" : ""}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      const name = art === "zugferd" ? `Rechnung_${rechnung.rechnungsnummer}_ZUGFeRD.pdf` : `XRechnung_${rechnung.rechnungsnummer}.xml`;
      a.href = url;
      a.download = res.headers["x-pruefung"] === "bestanden" ? name : `VORSCHAU_NICHT_GEPRUEFT_${name}`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      let detail = "E-Rechnung konnte nicht erstellt werden";
      try { detail = JSON.parse(await err.response.data.text()).detail || detail; } catch (e) { /* Blob ohne JSON */ }
      if (detail && detail.fehler) setFehler({ ...detail, art }); else toast.error(detail);
    }
    ladePruefungen();
  };

  return (
    <div className="mt-3" data-testid="erechnung-buttons">
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" onClick={() => laden("zugferd")} data-testid="erechnung-zugferd-btn">
          <FileCode2 size={14} className="mr-1" /> E-Rechnung (ZUGFeRD-PDF)
        </Button>
        <Button variant="outline" size="sm" onClick={() => laden("xrechnung")} data-testid="erechnung-xrechnung-btn">
          <FileCode2 size={14} className="mr-1" /> XRechnung (XML)
        </Button>
      </div>
      <div className="mt-2 space-y-1">{pruefungen.map((p) => <PruefStatus key={p.art} p={p} />)}</div>
      {fehler && <FehlerListe fehler={fehler} onVorschau={() => laden(fehler.art, true)} />}
    </div>
  );
};
